module.exports = __webpack_public_path__ + "img/woo.a7063c56.svg";